import { getCookie, setCookie } from '@convertdigital/gamma-cookie'
import { RECENTLY_CONFIG } from './constants'

const getCookieData = (cookieName, parser = (value) => value) => {
  const cookieValue = getCookie(cookieName) || ''

  try {
    return cookieValue ? parser(cookieValue) : []
  } catch (error) {
    console.error(`Error parsing ${cookieName} data:`, error)

    return []
  }
}

const getRecentlyProducts = () => getCookieData(RECENTLY_CONFIG.cookieName, (value) => value.split('|'))

const setRecentlyProducts = (id) => {
  let recentlyViewed = getRecentlyProducts()
  // Remove current product if it exists

  recentlyViewed = recentlyViewed.filter((i) => i !== id)
  // Push new product to start of list
  recentlyViewed.unshift(id)

  const newCookieValue = recentlyViewed.slice(0, RECENTLY_CONFIG.maxLimit).join('|')

  setCookie(RECENTLY_CONFIG.cookieName, newCookieValue, { expires: RECENTLY_CONFIG.expireTime })
}

const forceSetRecentlyProduct = (str) =>
  setCookie(RECENTLY_CONFIG.cookieName, str, { expires: RECENTLY_CONFIG.expireTime })

const getRecentlyProductsData = () => getCookieData(RECENTLY_CONFIG.cookieSkusName, JSON.parse)

const setRecentlyProductsData = (values) =>
  setCookie(RECENTLY_CONFIG.cookieSkusName, values, { expires: RECENTLY_CONFIG.expireTime })

export {
  setRecentlyProducts,
  getRecentlyProducts,
  setRecentlyProductsData,
  getRecentlyProductsData,
  forceSetRecentlyProduct
}
